import { createAsyncThunk } from "@reduxjs/toolkit";
import { getActiveDay, MENU_RANGES } from "../../utils/menuUtils";

export const fetchMenu = createAsyncThunk("menu/fetch", async () => {
  const today = getActiveDay();

  const range = MENU_RANGES[today];
  if (!range) throw new Error(`No menu range for ${today}`);

  const apiUrl = `${process.env.REACT_APP_GOOGLE_SHEET_SCRIPT}?range=${encodeURIComponent(range)}`;
  const res = await fetch(apiUrl);
  if (!res.ok) throw new Error("Failed to fetch menu");

  const rows = await res.json(); // [[row], [row], ...] — 8-column slices for today only
  return { day: today, rows };
});
